export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/qrcode.worker.46b4fe45.worker.js");
}
